const initialState = { dollarPrices: null, currentPrice: null };

const dollarPricesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_DOLLAR_PRICES": {
      const { data } = action;
      return {
        ...state,
        dollarPrices: data,
        currentPrice: data[0],
      }
    }
    case "UPDATE_DOLLAR_PRICE":
      return {
        ...state,
        currentPrice: { ...state.currentPrice, price: action.data },
      }

    default:
      return state;
  }
};

export default dollarPricesReducer;
